import { message } from "antd";
import React, { useEffect, useState } from "react";
import { getUserInfo } from "../apicalls/users";
import { useDispatch, useSelector } from "react-redux";
import { SetUser } from "../redux/usersSlice.js";
import { useNavigate } from "react-router-dom";

function ProtectedRoute({ children }) {
    const { user } = useSelector((state) => state.users);
    const [menu, setMenu] = useState([]);
    const dispatch = useDispatch();
    const [collapsed, setCollapsed] = useState(false);
    const navigate = useNavigate();

    const userMenu = [
        {
            title: "Home",
            paths: ["/" , "/user/write-exam"],
            icon: <i className="ri-home-line"></i>,
            onClick: () => navigate("/")
        },
        {
            title: "Reports",
            paths: ["/reports"],
            icon: <i className="ri-bar-chart-line"></i>,
            onClick: () => navigate("/user/reports")
        },
        {
            title: "Profile",
            paths: ["/logout"],
            icon: <i className="ri-logout-box-line"></i>,
            onClick: () => navigate("/profile")
        },
        {
            title: "Logout",
            paths: ["/profile"],
            icon: <i className="ri-user-line"></i>,
            onClick: () => {
                localStorage.removeItem("token");
                navigate("/login");
            },
        },
    ];

    const adminMenu = [
        {
            title: "Home",
            paths: ["/" , "/write-exam"],
            icon: <i className="ri-home-line"></i>,
            onClick: () => navigate("/")
        },
        {
            title: "Exams",
            path: ["/admin/exams", "/admin/exams/add", "/admin/exams/edit/:id"],
            icon: <i className="ri-file-list-line"></i>,
            onClick: () => navigate("/admin/exams"),
        },
        {
            title: "Reports",
            paths: ["/reports"],
            icon: <i className="ri-bar-chart-line"></i>,
            onClick: () => navigate("/admin/reports")
        },
        {
            title: "Profile",
            paths: ["/profile"],
            icon: <i className="ri-user-line"></i>,
            onClick: () => navigate("/profile")
        },
        {
            title: "Logout",
            paths: ["/logout"],
            icon: <i className="ri-logout-box-line"></i>,
            onClick: () => {
                localStorage.removeItem("token");
                navigate("/login");
            },
        },
    ];

    const getUserData = async () => {
        try {
          //dispatch(ShowLoading());
          const response = await getUserInfo();
          //dispatch(HideLoading());
          if (response.success) {
            dispatch(SetUser(response.data));
            if (response.data.isAdmin) {
              setMenu(adminMenu);
            } else {
              setMenu(userMenu);
            }
          } else {
            message.error(response.message);
          }
        } catch (error) {
          navigate("/login");
          //dispatch(HideLoading());
          message.error(error.message);
        }
      };

    useEffect(() => {
        if(localStorage.getItem("token")){
            getUserData();
        }else{
            navigate("/login");
        }
    }, [])

    /*const activeRoute = window.location.pathname;

    const getIsActiveOrNot = (paths) => {
        if (paths.includes(activeRoute)) {
            return true;
        } else {
            return false;
        }
    }*/

    return (
        <div className="layout">
            <div className="flex gap-2 w-full h-100">
                <div className="sidebar" style ={{height: "100%"}}>
                    <div className="menu">
                        {menu.map((item, index) => {
                            return (
                                <div
                                    className={
                                        `menu-item `
                                    }
                                    key={index}
                                    onClick={item.onClick}
                                >
                                    {item.icon}
                                    {!collapsed && <span>{item.title}</span>}
                                </div>
                            );
                        })}
                    </div>
                </div>
                <div className="body">
                    <div className="header flex justify-between">
                        {!collapsed && <i className="ri-close-line" onClick={() => setCollapsed(true)}></i>}
                        {collapsed && <i className="ri-menu-line" onClick={() => setCollapsed(false)}></i>}
                        <h1 className="text-2xl text-white">QuizVerse</h1>
                        <div className="flex gap-1 items-center">
                            <i className="ri-user-line"></i>
                            <h1 className="text-md text-white underline">{user?.name}</h1>
                        </div>
                    </div>
                    <div className="content">{children}</div>
                </div>
            </div>
        </div >
    )
}

export default ProtectedRoute;